export const initialValues = {
  tema: "",
  paket: "",
  bahasa: "",
  foto: "",
  linkFoto: "",
  namaAwal: "",
  panggilanWanita: "",
  lengkapWanita: "",
  wanitaAnakKe: "",
  namaIbuWanita: "",
  namaBapakWanita: "",
  panggilanPria: "",
  lengkapPria: "",
  priaAnakKe: "",
  namaIbuPria: "",
  namaBapakPria: "",
  akad: "",
  namaAcaraAkad: "",
  lainnyaAkad: "",
  hariAkad: "",
  pukulAkad: "",
  zonaWaktuAkad: "",
  tempatAkad: "",
  mapsAkad: "",
  namaAcaraResepsi: "",
  hariResepsi: "",
  resepsi: "",
  lainnyaResepsi: "",
  pukulResepsi: "",
  zonaWaktuResepsi: "",
  tempatResepsi: "",
  mapsResepsi: "",
  musik: "",
  loveStory: "",
  live: "",
  nomorRek: "",
  namaBank: "",
  atasNama: "",
  nomorRek2: "",
  namaBank2: "",
  atasNama2: "",
  daftarHadir: "",
  nomorCatin: "",
  alamat: "",
  namaPenerima: "",
  rsvp: "",
  waKonfirmasi: "",
  pakaiFilter: "",
  filterig: "",
  frame: "",
};
export const nameAcaraAkad = [
  { value: "Akad", text: "Akad" },
  { value: "Pemberkatan", text: "Pemberkatan" },
  { value: "Lainnya", text: "Lainnya" },
];
export const nameAcaraResepsi = [
  { value: "Resepsi", text: "Resepsi" },
  { value: "Walimatul Ursy", text: "Walimatul Ursy" },
  { value: "Lainnya", text: "Lainnya" },
];
export const namaPertama = [
  { value: "Wanita", text: "Wanita" },
  { value: "Pria", text: "Pria" },
];
export const bahasaPackages = [
  { value: "Indonesia", text: "Indonesia" },
  { value: "Inggris", text: "Inggris" },
];
export const pakaiFilterPackages = [
  { value: "Iya", text: "Iya" },
  { value: "Tidak", text: "Tidak" },
];
export const filterPackages = [
  { value: "Filter Wedding P", text: "Filter Wedding P" },
  { value: "Filter Wedding Q", text: "Filter Wedding Q" },
  { value: "Filter Wedding W", text: "Filter Wedding W" },
  { value: "Filter Wedding X", text: "Filter Wedding X" },
  { value: "Filter Wedding Y", text: "Filter Wedding Y" },
  { value: "Filter Wedding Z", text: "Filter Wedding Z" },
  { value: "Filter Wedding AA", text: "Filter Wedding AA" },
  { value: "Filter Wedding AC", text: "Filter Wedding AC" },
  { value: "Filter Wedding AD", text: "Filter Wedding AD" },
  { value: "Filter Wedding AE", text: "Filter Wedding AE" },
  { value: "Filter Wedding AF", text: "Filter Wedding AF" },
  { value: "Filter Wedding 01", text: "Filter Wedding 01" },
  { value: "Filter Wedding 02", text: "Filter Wedding 02" },
  { value: "Filter Wedding Jawa", text: "Filter Wedding Jawa" },
];
export const framePackages = [
  { value: "Frame 1", text: "Frame 1" },
  { value: "Frame 1 dan 2", text: "Frame 1 dan 2" },
  { value: "Frame 1, 2 dan 3", text: "Frame 1, 2 dan 3" },
];
export const undanganPackages = [
  { value: "Dengan Foto", text: "Dengan Foto" },
  { value: "Tanpa Foto", text: "Tanpa Foto" },
  { value: "Animasi", text: "Animasi" },
];
export const zona = [
  { value: "WIB", text: "WIB" },
  { value: "WITA", text: "WITA" },
  { value: "WIT", text: "WIT" },
];
export const namaHari = [
  { value: "Senin", text: "Senin" },
  { value: "Selasa", text: "Selasa" },
  { value: "Rabu", text: "Rabu" },
  { value: "Kamis", text: "Kamis" },
  { value: "Jumat", text: "Jumat" },
  { value: "Sabtu", text: "Sabtu" },
  { value: "Minggu", text: "Minggu" },
];
export const webThemes = [
  { value: "Tema P", text: "Tema P" },
  { value: "Tema Q", text: "Tema Q" },
  { value: "Tema W", text: "Tema W" },
  { value: "Tema X", text: "Tema X" },
  { value: "Tema Y", text: "Tema Y" },
  { value: "Tema Z", text: "Tema Z" },
  { value: "Tema AA", text: "Tema AA" },
  { value: "Tema AC", text: "Tema AC" },
  { value: "Tema AD", text: "Tema AD" },
  { value: "Tema AE", text: "Tema AE" },
  { value: "Tema AF", text: "Tema AF" },
  { value: "Tema AG", text: "Tema AG" },
  { value: "Tema 01", text: "Tema 01" },
  { value: "Tema 02", text: "Tema 02" },
  { value: "Tema 03", text: "Tema 03" },
  { value: "Tema 04", text: "Tema 04" },
  { value: "Tema Jawa", text: "Tema Jawa" },
  { value: "Tema Batak", text: "Tema Batak" },
  { value: "Tema Minang", text: "Tema Minang" },
  { value: "Tema Aqiqah", text: "Tema Aqiqah" },
];
